define('view/controller/online-meeting/OnlineMeetingView',['require','lib/view/LayoutView'],function (require) {

	var Parent = require('lib/view/LayoutView');
	
	/**
	 * Online meeting view
	 * 
	 * @class OnlineMeetingView
	 */
	return Parent.extend({

		template: '#online_meeting_view',
        
        ui: {
            'startBtn': '.sb-start'
        },
        
        triggers: {
            'click @ui.startBtn': 'start'
        },
        
        modelEvents: {
            'sync': 'render'
        },
        
        initialize: function () {
            Parent.prototype.initialize.apply(this);
            
            this._isProvider = this.getOption('is_provider');
            
            var _this = this;
            this._refreshInterval = setInterval(function () {
                if (!_this.isDestroyed) {
                    _this.model.fetch();
                } else {
                    clearInterval(_this._refreshInterval);
                    _this._refreshInterval = undefined;
                }
            }, 10000);
        },
        
        serializeData: function () {
            return _.extend({}, Parent.prototype.serializeData.apply(this), {
                is_provider: this._isProvider
            });
        },
        
        // onRender: function () {
        //     var options = this.model.get('options');
        //     if (options && options.join_url) {
        //         window.location = options.join_url;
        //     }
        // },

		onDomRefresh: function () {
			this.onShowPage();
		},

		onShowPage: function () {
			Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
				'page': 'online_meeting'
			});
		}

	});
	
});
